"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFirstFocusedRender = exports.instanceId = exports.notify = exports.validateList = void 0;
var _1 = require("./_");
var invariant_1 = __importDefault(require("./invariant"));
var METHODS = ['next', 'prev', 'first', 'last'];
function validateList(list) {
  if (process.env.NODE_ENV !== 'production') {
    METHODS.forEach(function (method) {
      return invariant_1.default(typeof list[method] === 'function', 'List components must implement a `' + method + '()` method');
    });
  }
}
exports.validateList = validateList;
function notify(handler, args) {
  handler && handler.apply(void 0, [].concat(args));
}
exports.notify = notify;
function instanceId(component, suffix) {
  if (suffix === void 0) {
    suffix = '';
  }
  component.__id || (component.__id = _1.uniqueId('vdl_'));
  return (component.props.id || component.__id) + suffix;
}
exports.instanceId = instanceId;
function isFirstFocusedRender(component) {
  return component._firstFocus || component.state.focused && (component._firstFocus = true);
}
exports.isFirstFocusedRender = isFirstFocusedRender;